
import React from 'react'

export default props => (
  <svg {...props} className="ChangeColorDark roundButton" width="32" height="32" viewBox="0 0 32 32" fill="none">
    <path fillRule="evenodd" clipRule="evenodd" d="M16 30C23.732 30 30 23.732 30 16C30 8.26801 23.732 2 16 2C8.26801 2 2 8.26801 2 16C2 23.732 8.26801 30 16 30ZM16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" />
    <path fillRule="evenodd" clipRule="evenodd" d="M23.1952 19.5011C22.3588 19.8233 21.45 20 20.5 20C16.3579 20 13 16.6421 13 12.5C13 10.8845 13.5107 9.38838 14.3795 8.16418C10.7382 8.9133 8 12.1369 8 16C8 20.4183 11.5817 24 16 24C19.1627 24 21.8967 22.1647 23.1952 19.5011Z" />
  </svg>
)
